import { ActionType, createAction, getType } from "typesafe-actions";
import { TypeVoie } from "../../services/Api/swagger";

export interface TypeVoieState {
  data?: TypeVoie[];
}

export const initialState: TypeVoieState = {
  data: [],
};

export const loadTypeVoieAsync = createAction("@@App/typeVoie/LOAD_SUCCESS")<
  TypeVoie[]
>();

export const ActionCreators = {
  loadTypeVoieAsync,
};

const getListTypeVoie = (state: any): TypeVoie[] => state.typeVoie.data;

export const Selectors = {
  getListTypeVoie,
};

export const reducer = (
  state: TypeVoieState = initialState,
  action: ActionType<typeof ActionCreators>
): TypeVoieState => {
  if (action.type === getType(loadTypeVoieAsync)) {
    return {
      ...state,
      data: action.payload,
    };
  }

  return state;
};
